import React from "react";
import { getWidgetDetails } from "../../../../../utils/helpers";
import * as Styled from "./styles";
const WidgetDisplay = ({ name }) => {
  const { icon, title } = getWidgetDetails(name);

  return (
    <>
      {title ? (
        <>
          <Styled.ImageDiv>
            {icon && <img src={icon} alt="Icon" width={24} height={24} />}
          </Styled.ImageDiv>
          <Styled.paragraphDiv>
            <Styled.paragraphText>{title}</Styled.paragraphText>
          </Styled.paragraphDiv>
        </>
      ) : (
        name
      )}
    </>
  );
};

export default WidgetDisplay;
